import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { toQueryParams } from '../components/auth/login/login.component';

@Injectable({
  providedIn: 'root'
})
export class AfterLoginGuard implements CanActivateChild {

  constructor(private _cookie: CookieService, private _route: Router,private cookie: CookieService) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const sessionId = localStorage.getItem('sessionID');
     var routPath = state.url.substring(0,17)
    if (sessionId === undefined || sessionId === null || sessionId === '') {
      return true;
    }else if(routPath=='/setPassword?jsr='){
      //  Swal.fire({
      //   title: 'There is already a logged in user in another tab/browser. Please log out of the application from that tab/browser and then create the password',
      //     confirmButtonText: 'OK',
      //  }).then((result) => {
      //   /* Read more about isConfirmed, isDenied below */
      // })
      return true;
    }

    const data : any = state.root.queryParamMap;
    let token = localStorage.getItem('token');
    if(token && data.params.redirectTo && data.params.data){
        // console.log("log route " , data.params)
        let redirectTo = null;
        if (data.params.redirectTo.startsWith('/business')) {
          // business links come encoded once, so `data` is already plain JSON;
          // decoding again throws on a literal '%' (e.g. "up to 40%")
          try {
            redirectTo = `${data.params.redirectTo}?${toQueryParams(JSON.parse(data.params.data))}`;
          } catch (e) {
            redirectTo = null;
          }
        } else {
          redirectTo = `${data.params.redirectTo}?${toQueryParams(JSON.parse(decodeURIComponent(data.params.data)))}`;
        }
        if(redirectTo){
          this._route.navigateByUrl(redirectTo);
        }
        else{
          this._route.navigate(['/landingPage']);
        }
    }
    else if(token && data.params.redirectTo){
      // Inline-param link (e.g. redirectTo=/personalProfile?userId=… with
      // absolutePath=true but NO data blob). `redirectTo` is already a
      // complete path+query, so navigate straight to it instead of
      // dropping the logged-in user on landingPage. Mirrors the
      // login.component fix for the logged-out case.
      this._route.navigateByUrl(data.params.redirectTo);
    }
    else if(token){
      this._route.navigate(['/landingPage']);
    }else {
      this.clear();
    }
    return false;
  }

  clear(){
    this.cookie.deleteAll();
      let allCookies = document.cookie.split(';');
      if (allCookies) {
        for (let i = 0; i < allCookies.length; i++) {
          document.cookie = allCookies[i] + "=;expires="
            + new Date(0).toUTCString();
        }
      }
      localStorage.clear();
      this._route.navigate(['/auth/login']);
  }
}
